export function safeParseJson(text: string): unknown {
  try { return JSON.parse(text) } catch { return null }
}

export function extractErrorMessage(data: unknown): string | null {
  if (!data) return null
  if (typeof data === 'string') return data
  if (typeof data === 'object') {
    const record = data as Record<string, unknown>
    if (typeof record.error === 'string') return record.error
    if (typeof record.message === 'string') return record.message
    if (typeof record.error === 'object' && record.error) {
      const nested = record.error as Record<string, unknown>
      if (typeof nested.message === 'string') return nested.message
    }
  }
  return null
}

export function formatAuthError(status: number, data: unknown): string {
  if (status === 429) return 'Too many attempts. Please wait a moment and try again.'
  if (status === 502 || status === 503 || status === 504) return 'Login service is temporarily unavailable. Please try again.'
  if (status === 403 && data && typeof data === 'object') {
    const parsed = data as Record<string, unknown>
    if (parsed.error === 'account_suspended') return 'This account has been suspended. Please contact support.'
    if (parsed.error === 'account_deleted') return 'This account has been deleted. Please contact support.'
  }
  return extractErrorMessage(data) || 'Failed to log in. Please try again.'
}

export function formatNetworkError(error: unknown): string {
  if (error instanceof TypeError) return 'Network error while contacting the login service. Please check your connection and try again.'
  if (error instanceof Error && error.message) {
    const msg = error.message.toLowerCase()
    if (msg.includes('failed to fetch') || msg.includes('network') || msg.includes('load failed'))
      return 'Unable to reach the server. Please check your connection and try again.'
    return error.message
  }
  return 'Unable to connect to the server. Please check your internet connection and try again.'
}

export function shouldShowConnectionScreen(status?: number, error?: unknown): boolean {
  if (typeof status === 'number' && status >= 500) return true
  if (error instanceof TypeError) return true
  if (error instanceof Error) {
    const message = error.message.toLowerCase()
    return message.includes('failed to fetch') || message.includes('network') || message.includes('timed out') || message.includes('timeout') || message.includes('load failed') || message.includes('the internet connection appears to be offline')
  }
  if (error && typeof error === 'object' && Object.keys(error).length === 0) return true
  return false
}
